import React, { Component } from 'react';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';

class App extends Component {
    render() {
        return (
            <div>
                <Navbar />
                <div className="Content" id="content">
                    {this.props.children}
                </div>
                <Footer />
            </div>
        );
    }
};

App.contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.object
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/